<template>
    <div class="data-view">
        <ns-loader
            :fetch-timer="null"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
            ref="dataView"
        >
            <template slot="content">
                <div>
                    <el-button
                        @click="$router.go(-1)"
                    >Retourner au site</el-button>
                </div>
                <GlobalDataView
                    :entity="entity"
                    :uid="entityUid"
                    :start-date="startDate"
                    :end-date="endDate"
                    :consumption-data="[active_global_consumption_data]"
                    :power-data="[active_global_power_data]"
                ></GlobalDataView>
                <WeeklyDataView
                    :uid="entityUid"
                    :entity="entity"
                    :consumption-data="active_weekly_consumption_data"
                    :power-data="active_weekly_power_data"
                ></WeeklyDataView>
                <DailyDataView
                    :uid="entityUid"
                    :entity="entity"
                    :consumption-data="active_daily_consumption_data"
                    :power-data="active_daily_power_data"
                ></DailyDataView>
            </template>
        </ns-loader>
    </div>
</template>

<script>
import moment from 'moment';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2';
import DailyDataView from './DailyDataView.vue';
import WeeklyDataView from './WeeklyDataView.vue';
import GlobalDataView from './GlobalDataView.vue';
export default {
    name: 'DataView',
    components: {
        NsLoader,
        DailyDataView,
        WeeklyDataView,
        GlobalDataView
    },
    data() {
        return {
            entity: null,
            entityUid: null,
            startDate: null,
            endDate: null,
            active_daily_consumption_data: [],
            active_daily_power_data: [],
            active_daily_data: [],
            active_global_consumption_data: null,
            active_global_consumption_percent_by_children: null,
            active_global_power_data: [],
            active_weekly_consumption_data: [],
            active_weekly_power_data: [],
            active_weekly_data: []
        }
    },
    computed: {
        currentModel(){
            switch (this.entity) {
                case 'zone':
                    return 'areaSimulationResults';
                case 'machine':
                    return 'equipmentSimulationResults';
                case 'workshop':
                    return 'areaSimulationResults';
                case 'motor':
                    return 'equipmentSimulationResults';
                default:
                    return 'siteSimulationResults';
            }
        },
        currentFilters(){
            switch (this.entity) {
                case 'workshop':
                    return { area_uid: this.entityUid };
                case 'motor':
                    return { equipment_uid: this.entityUid };
                case 'zone':
                    return { area_uid: this.entityUid };
                case 'machine':
                    return { equipment_uid: this.entityUid };
                default:
                    return { site_uid: this.entityUid };
            }
        },
        toLoad() { 
            return[
                {
                    model: this.currentModel,
                    name: this.currentModel,
                    filters:{
                        is_latest: true,
                        ...this.currentFilters
                    }
                }
            ];
        }
    },
    created(){
        this.$set(this, 'entity', this.$route.params.entity);
        this.$set(this, 'entityUid', this.$route.params.uid);
        this.$set(
            this, 
            'startDate', 
            moment(this.$route.params.start_date)
            .tz("Europe/Paris")
            .format('DD/MM/YYYY')
        );
        this.$set(
            this, 
            'endDate', 
            moment(this.$route.params.end_date)
            .tz("Europe/Paris")
            .format('DD/MM/YYYY')
        );
    },
    methods:{
        onDataFetched(res) {
            this.setDatas(res[this.currentModel][0]);
        },
        setDatas(data) {
            this.$set(this, 'active_daily_consumption_data', data.active_daily_consumption_data)
            this.$set(this, 'active_daily_power_data', data.active_daily_power_data)
            this.$set(this, 'active_global_consumption_data', data.active_global_consumption_data)
            this.$set(this, 'active_global_consumption_percent_by_children', data.active_global_consumption_percent_by_children)
            this.$set(this, 'active_global_power_data', data.active_global_power_data)
            this.$set(this, 'active_weekly_consumption_data', data.active_weekly_consumption_data)
            this.$set(this, 'active_weekly_power_data', data.active_weekly_power_data)
            if(this.entity !== 'motor' && this.entity !== 'machine'){
                this.$set(this, 'active_daily_data', data.active_daily_data)
                this.$set(this, 'active_weekly_data', data.active_weekly_data)
            }
        }
    }
}
</script>

<style lang="scss">
.data-view{
    padding: 20px 40px;
    h1{
        font-size: 24px;
        margin: 20px;
        text-align: center;
        font-weight: 700;
        text-transform: uppercase;
    }
    .power-graphs-container{
        display: grid;
        grid-template-columns: repeat(2, minmax(300px, 1fr));
        gap: 20px;
        overflow-y: auto;
        max-height: 700px;
        > *:only-child {
            grid-column: 1 / -1; /* occupe toutes les colonnes */
        }
    }
    &-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: stretch;
        .table-container{
            width: 100%;
            margin-bottom: 2rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page/DataView/Index.vue